import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const heroImage = process.env.PUBLIC_URL + '/hero-ai.jpg.jpg';

const HomePage: React.FC = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero split-hero">
        <div className="hero-image-side">
          <img src={heroImage} alt="Hero placeholder image" className="hero-photo" />
        </div>
        <div className="hero-card-side">
          <div className="hero-card hero-content-overlay">
            <h1 className="hero-title">
              🐾 Welcome to <span className="brand-name">Woofly</span>
            </h1>
            <p className="hero-tagline">Paws United</p>
            <p className="hero-description">
              Bringing communities together to help street dogs in India, one city at a time.
            </p>
            <div className="hero-buttons">
              <Link to="/ngos" className="btn btn-primary">
                Find NGOs Near You
              </Link>
              <Link to="/about" className="btn btn-secondary">
                Learn Our Story
              </Link>
            </div>
          </div>
        </div>
      </section>
      <div className="below-hero-bg">
        {/* Mission Section */}
        <section className="mission-section">
          <div className="container">
            <h2>Our Mission</h2>
            <p className="mission-text">
            Our mission is to unite dog welfare NGOs and compassionate brands to create lasting impact for street dogs in India—through storytelling, support, and shared purpose.
            </p>
          </div>
        </section>
        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <h2>Our Impact</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">💉</div>
                <h3>Vaccination </h3>
                <p>Most hate for street dogs is driven by the fear of rabies. We are working to make India a rabies-free country.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🍲</div>
                <h3>Feeding Programs</h3>
                <p>Ensuring daily nutrition for street dogs through partnerships with NGOs in India.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">⚖️</div>
                <h3>Fighting for Dogs</h3>
                <p>When dogs are hurt or abused the NGOs we fund step in and fight cases in court for dogs.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🤝</div>
                <h3>Community Building</h3>
                <p>We are connecting NGOs with the community to create a better world for street dogs.</p>
              </div>
            </div>
          </div>
        </section>
        {/* Call to Action */}
        <section className="cta-section">
          <div className="container">
            <h2>Ready to Make a Difference?</h2>
            <p>Join our community of animal lovers and help create a better world for street dogs.</p>
            <div className="cta-buttons">
              <Link to="/ngos" className="btn btn-primary">
                Explore NGO Directory
              </Link>
              <Link to="/brands" className="btn btn-secondary">
                Partner With Us
              </Link>
            </div>
          </div>
        </section>
        {/* Removed stats section as requested */}
      </div>
    </div>
  );
};

export default HomePage; 